<template>
  <div :id="mapId" :style="styles" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  model: {
    prop: 'data',
    event: 'set-object'
  },

  props: {
    show: { type: Boolean, default: () => false },

    data: {
      type: Object,
      default: () => {}
    },

    mapId: {
      type: String,
      default: () => 'map'
    },

    dark: {
      type: Boolean,
      default: () => false
    },

    width: {
      type: String,
      default: () => '100%'
    },

    height: {
      type: String,
      default: () => '100%'
    }
  },

  data () {
    return {
      map: undefined,
      google: null,
      objectMarker: null,
      objectPolygon: null,
      drawer: undefined,
      drawZone: null,
      listener: undefined
    }
  },

  computed: {
    ...mapGetters(['color']),

    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('set-object', value)
      }
    },

    styles () {
      return `
        width: ${this.width};
        height: ${this.height};
        z-index: 1;
      `
    },

    polygonColor () {
      if (this.object.type === 'GEOFENCE') {
        return '#0070A8'
      }
      if (this.object.type === 'RESTRICTED') {
        return '#FFC107'
      }
      return '#F44336'
    }
  },

  watch: {
    show (value) {
      if (value) {
        if (this.map && this.object.id) {
          this.paintPolygon(this.object.points)
        }
      } else {
        if (this.objectPolygon) {
          this.removePolygon()
        }
      }
    }
  },

  beforeCreate () {
    /* eslint-disable no-undef, no-unused-vars */
    this.$googlemaps.load().then(() => {
      this.google = google
      this.initMap()
    })
    /* eslint-enable */
  },

  created () {},

  mounted () {},

  beforeDestroy () {},

  methods: {
    async initMap () {
      let initialLocation = { lat: 0, lng: 0 }

      this.map = new this.google.maps.Map(
        document.getElementById(this.mapId),
        {
          zoom: 16,
          center: initialLocation
        }
      )
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          initialLocation = new self.google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          self.map.setCenter(initialLocation)
        })
      }

      setTimeout(() => {
        if (this.object.id) {
          this.paintPolygon(this.object.points)
        }
        this.initDrawer()
      }, 0)
    },

    /**
     * Initialize Google Map Drawer
     */
    initDrawer () {
      const google = this.google
      this.drawer = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.RIGHT,
          drawingModes: [
            google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON,
            google.maps.drawing.OverlayType.POLYLINE
          ]
        },
        polygonOptions: {
          fillColor: this.polygonColor, // color
          strokeColor: this.polygonColor, // color
          fillOpacity: 0.35,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      })

      google.maps.event.addListener(this.drawer, 'overlaycomplete', this.attach)
    },

    attach (event) {
      /**
       * Erase the previous overlay if it exist
       */
      if (this.drawZone) {
        this.google.maps.event.removeListener(this.listener)
        this.drawZone.setMap(null)
      }

      this.stopDrawing()
      const { overlay } = event
      const path = []

      const vertices = overlay.getPath()

      for (let i = 0; i < vertices.getLength(); i++) {
        const xy = vertices.getAt(i)
        path.push({
          latitude: xy.lat(),
          longitude: xy.lng()
        })
      }

      this.object.points = path
      this.drawZone = overlay
      this.listener = this.google.maps.event.addListener(this.drawZone.getPath(), 'set_at', this.updateDrawZone)
    },

    paintPolygon (points) {
      const color = this.zoneColor(this.object.type)
      const coors = points.map(el => {
        return {
          lat: el.latitude,
          lng: el.longitude
        }
      })

      this.objectPolygon = new this.google.maps.Polygon({
        paths: coors,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35
      })

      this.objectPolygon.setMap(this.map)
      this.CenterInMap(this.object.points)
    },

    setPolygon () {
      if (this.map && this.objectPolygon) {
        const path = this.objectPolygon.getPath()

        this.drawZone = new this.google.maps.Polygon({
          paths: path,
          strokeColor: this.polygonColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.polygonColor,
          fillOpacity: 0.35
        })
        this.drawZone.setMap(this.map)
        this.drawZone.setEditable(true)
        this.objectPolygon.setMap(null)
        this.objectPolygon = null

        this.listener = this.google.maps.event.addListener(this.drawZone.getPath(), 'set_at', this.updateDrawZone)
      }
    },

    updateDrawZone (event) {
      console.log('draw zone')
      const path = []

      const vertices = this.drawZone.getPath()

      for (let i = 0; i < vertices.getLength(); i++) {
        const xy = vertices.getAt(i)
        path.push({
          latitude: xy.lat(),
          longitude: xy.lng()
        })
      }

      this.object.points = path
    },

    CenterInMap (points) {
      const coors = points.map(el => {
        return new this.google.maps.LatLng(el.latitude, el.longitude)
      })
      var bounds = new this.google.maps.LatLngBounds()
      var i

      for (i = 0; i < coors.length; i++) {
        bounds.extend(coors[i])
      }
      this.map.setCenter(bounds.getCenter())
    },

    zoneColor (type) {
      let result = '#0070A8'
      switch (type) {
        case 'RESTRICTED':
          result = '#FFC107'
          break

        case 'DANGEROUS':
          result = '#F44336'
          break

        default:
          break
      }

      return result
    },

    removePolygon () {
      this.objectPolygon.setMap(null)
      this.objectPolygon = null
    },

    removeMarker () {
      this.objectMarker.setMap(null)
      this.objectMarker = null
    },

    placeMarker (location) {
      this.objectMarker = new this.google.maps.Marker({
        position: location,
        map: this.map
      })
      setTimeout(() => {
        this.map.setCenter(this.objectMarker.getPosition())
      }, 100)
    },

    drawPolygon () {
      this.drawer.setOptions({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        polygonOptions: {
          fillColor: this.polygonColor, // color
          strokeColor: this.polygonColor, // color
          fillOpacity: 0.3,
          strokeOpacity: 1,
          strokeWeight: 4,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      })

      this.drawer.setMap(this.map)
    },

    setColor () {
      if (this.drawZone) {
        this.drawZone.setOptions({
          fillColor: this.polygonColor,
          strokeColor: this.polygonColor
        })
      }
    },

    stopDrawing () {
      this.drawer.setMap(null)
    },

    cleanPolygons () {
      if (this.drawZone) {
        this.drawZone.setMap(null)
      }
      this.drawZone = null
    }
  }
}
</script>
